anonLanguageAlertBarAccepted